import { ApiResponse } from "@/utils/ApiResponse";
import apiClient from "@/clients/apiClient";
import { ProveedorInterface } from "../../interfaces/proveedorInterfaces/Proveedor.interface";

export async function DeleteProveedorAction (
    proveedorId: string
): Promise<ApiResponse<ProveedorInterface>> {
   const {data} = await apiClient.delete(`gpProveedoresProducto/${proveedorId}`);
    return {
        status: 200,
        data,
        message: "Proveedor de producto eliminada correctamente",
    };
}
    